import React from 'react';
import { View, FlatList, RefreshControl } from 'react-native';

import Colors from '../../constants/Colors';
import {queryNews} from "./api/queryNews";
import NewsComponent from "./NewsComponent";
import NavBar from "../../components/NavBar";
import {SpinnerControl} from "../../components";

class NewsScreen extends React.Component {

    state = {
        isFetching: false,
        news: [],
    }

    fetchNews = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true });

        try {
            const newsFetchResult = await queryNews();
            this.setState({ news: newsFetchResult });
        } catch (e) {
            console.log(e)
        }

        this.setState({ isFetching: false });
    }

    componentDidMount() {
        this.fetchNews();
    }

    render() {
        return (
            <NavBar title={"Notícias"}>

                <SpinnerControl isFetching={this.state.isFetching} />

                <FlatList
                    data={this.state.news}
                    renderItem={({item}) => {
                        return <NewsComponent data={item} />
                    }}
                    keyExtractor={item => item.SK.toString()}
                    refreshControl={
                        <RefreshControl
                            refreshing={this.state.isFetching}
                            onRefresh={() => this.fetchNews()}
                            colors={[Colors.spinnerColor]}
                            title={'Carregando notícias!'}

                        />
                    }
                    contentContainerStyle={{ alignItems: 'center' }}
                />

            </NavBar>
        )
    }
}

export default NewsScreen;
